import { gql } from '@apollo/client';

export const ALL_PROGRAMMES = gql`
  query AllProgrammes {
    programmes {
      id
      name
    }
  }
`;
